<template>
  <v-card flat tile>
    <v-row no-gutters class="mt-0">
      <v-col cols="6" v-if="!componentStep">
        <v-switch
          v-model="enablePage"
          label="page"
          class="mt-0 mb-2"
          color="grey darken-3"
          dense
          hide-details
          @change="togglePage"
        />
      </v-col>

      <v-col cols="6" v-if="enablePage">
        <v-switch
          v-model="value[getSelected].page.setAutomatically"
          label="setAutomatically"
          class="mt-0 mb-2"
          color="grey darken-3"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6" v-if="enablePage">
        <v-text-field
          v-model="value[getSelected].page.page"
          label="page"
          class="mr-1 mb-2"
          color="grey darken-3"
          hide-details
        />
      </v-col>

      <v-col cols="6" v-if="enablePage">
        <v-select
          v-model="value[getSelected].page.mode"
          :items="['list', 'form', 'new', 'search', 'sidebar']"
          class="ml-1 mb-2"
          color="grey darken-3"
          label="Value"
          append-icon="zmdi zmdi-chevron-down"
          hide-details
        />
      </v-col>

      <v-col cols="12" v-if="!enablePage">
        <v-text-field
          v-model="value[getSelected].procedure.name"
          class="mt-4 mb-2"
          color="grey darken-3"
          label="Procedure"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6">
        <v-switch
          v-model="value[getSelected].disabled"
          label="disabled"
          class="mt-1 mb-3"
          color="grey darken-3"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6">
        <v-switch
          v-model="value[getSelected].reverseOrder"
          label="reverseOrder"
          class="mt-1 mb-3"
          color="grey darken-3"
          dense
          hide-details
        />
      </v-col>
    </v-row>

    <v-expansion-panels v-if="!enablePage" class="accordion-list-components" hover focusable>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3"
            >Conditions {{ componentStep ? 'Step ' : 'Tab ' }} {{ getSelected }}</span
          >
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <DevConditions :conditions="value[getSelected].conditions" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import store from '@/store';

export default {
  mixins: [abstractField],

  components: {
    DevConditions: () => import('@/components/dev/dev-conditions')
  },

  data: () => ({
    enablePage: false,
    componentStep: false
  }),

  mounted() {
    'page' in this.value[this.getSelected || 1] ? (this.enablePage = true) : (this.enablePage = false);

    if ('typeComponent' in this.schema && this.schema.typeComponent == 'step') {
      this.componentStep = true;
    }
  },

  computed: {
    getSelected() {
      if (this.componentStep) {
        return parseInt(this.$store.getters['dev/getSelectedStep']) + 1;
      }
      return parseInt(this.$store.getters['dev/getSelectedTab']) + 1;
    }
  },

  methods: {
    togglePage(e) {
      const page = {
        mode: '',
        page: '',
        setAutomatically: false
      };

      if (!e) delete this.value[this.getSelected].page;

      if (e) {
        this.value[this.getSelected].page = page;

        // --> Limpa (actions, fields e groups) ao utilizar page na tab!
        this.value[this.getSelected].actions = {};
        this.value[this.getSelected].fields = [];
        this.value[this.getSelected].groups = [];
        this.value[this.getSelected].conditions = {
          fields: [],
          hide: {
            actions: [],
            fields: []
          }
        };
      }
    }
  },

  watch: {
    getSelected(newValue) {
      'page' in this.value[this.getSelected || 1] ? (this.enablePage = true) : (this.enablePage = false);
    }
  }
};
</script>
